import { Badge } from '@asad/ui'
import { BellIcon, CircleCheckIcon, CircleAlertIcon } from 'lucide-react'

import { DeviceDetailsResponse } from '@/api/device.api'
import { generalStatusText, statusBagdeVariant } from '@/utils/utils'
import { useDeviceDataContext } from '@/context/DevicesContext'
import { Loader } from '@/components'

type StatusVariant = 'success' | 'error' | 'warning'

type TitleProps = {
  device?: DeviceDetailsResponse
}

const Title = ({ device }: TitleProps) => {
  const { id, name, serialNumber, udtNumber } = device || {}

  const { devicesStatuses } = useDeviceDataContext()
  const alertStatus = devicesStatuses.find((device) => device.id === id)?.alertStatus
  const deviceStatusBadgeVariant = statusBagdeVariant(alertStatus)
  const deviceStatus = generalStatusText(alertStatus)

  const statusIconProps: Record<StatusVariant, { icon: React.ComponentType<any> }> & {
    default: { icon: React.ComponentType<any> }
  } = {
    success: { icon: CircleCheckIcon },
    error: { icon: BellIcon },
    warning: { icon: CircleAlertIcon },
    default: { icon: CircleAlertIcon },
  }

  const getDeviceStatusIcon = (variant: string, size = 20) => {
    const Icon = (statusIconProps as any)[variant]?.icon || statusIconProps.default.icon

    return <Icon size={size} />
  }
  return (
    <div className='flex justify-between flex-col md:flex-row gap-2 2xl:pr-24 font-semibold w-full mb-4'>
      {device ? (
        <>
          <div className='flex items-center gap-3'>
            <span className='lg:text-3xl text-lg'>{name}</span>
            <span className='lg:text-3xl text-lg'>\</span>
            <span>{`SN: ${serialNumber}`}</span>
            <span className='lg:text-3xl text-lg'>\</span>
            <span>{`UDT: ${udtNumber || '-------'}`}</span>
          </div>
          <Badge badgeSize='xl' variant={deviceStatusBadgeVariant} fill='outline'>
            <div className='flex flex-row items-center gap-2'>
              {getDeviceStatusIcon(deviceStatusBadgeVariant)}
              <span>{deviceStatus}</span>
            </div>
          </Badge>
        </>
      ) : (
        <Loader containerFullWidth={false} displayLoadingText={false} size='40' />
      )}
    </div>
  )
}

export default Title
